export default __webpack_public_path__ + "static/media/awoken-logo.4a2e8169.png";